<template>
  <div
    v-if="refreshToken in savedJourneys"
    class="btn btn-primary"
    @click.stop="store.refreshSavedJourney(refreshToken)"
  >
    <i class="icon icon-arrow-clockwise"></i>
  </div>
</template>

<script setup lang="ts">
import { useMainStore } from '~/stores/main'
import { storeToRefs } from 'pinia'

const store = useMainStore()
const { savedJourneys } = storeToRefs(store)

defineProps<{
  refreshToken: string
}>()
</script>
